import { render } from "./ConnectOnboarding.vue?vue&type=template&id=70aacd41&scoped=true"
import script from "./ConnectOnboarding.vue?vue&type=script&lang=js"
export * from "./ConnectOnboarding.vue?vue&type=script&lang=js"

import "./ConnectOnboarding.vue?vue&type=style&index=0&id=70aacd41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aacd41"]])

export default __exports__